import React, { useContext, useState } from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { Settings } from "../../../helpers/Contexts";
import { MdClose, MdCheck } from "react-icons/md";
import * as API from "../../../api";
import FieldError from "../../../shared/FieldError";
import Select from "react-select";
import * as CONST from "../../../helpers/Constants";

const KidneyFunctionTest = ({ task, values, data, handleField }) => {
  const KidneyFunctionTestSchema = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .matches(/^\d{1,4}$/, "Valid format is a number."),
  });
  let valuesPresent = Array.isArray(values) && values.length > 0;
  let kidneyFunctionTestQmValue = valuesPresent ? values.find((el) => CONST.KIDNEY_FUNCTION_TEST.includes(el.name)) : null
  const initialValue = kidneyFunctionTestQmValue ? { value: kidneyFunctionTestQmValue.value, label: kidneyFunctionTestQmValue.name, id: kidneyFunctionTestQmValue.id, quality_measurement_type_id: kidneyFunctionTestQmValue.quality_measurement_type_id } : { label: "", value: "" };
  const [showTextInput, setShowTextInput] = useState(valuesPresent && CONST.KIDNEY_FUNCTION_REQUIRING_INPUT.includes(values[0].name));

  const settings = useContext(Settings);
  const options = settings.kidney_function_test_options;
  let qmIds = Array.isArray(values) ? values.map((el) => el.id) : null;

  async function postSelectedMeasurement(e) {
    let req = {
      patient_id: task.patient.uid,
      cpr_id: task.cpr.id,
      value: true,
      quality_measurement_type_id: e.quality_measurement_type_id,
    };

    const res = await API.postQualityMeasurement(
      task.cpr.attending_provider
        ? { quality_measurement: { ...req, attending_provider: task.cpr.attending_provider } }
        : { quality_measurement: { ...req } }
    );
    return res;
  }

  async function handleMeasurement(e) {
    if (CONST.KIDNEY_FUNCTION_REQUIRING_INPUT.includes(e.label)) {
      setShowTextInput(true);
    } else {
      task.dispatch({ type: "set_loading", payload: true });

      if (kidneyFunctionTestQmValue && kidneyFunctionTestQmValue.id) {
        await API.deleteQualityMeasurement({ quality_measurement_ids: [kidneyFunctionTestQmValue.id] });
      }
      await postSelectedMeasurement(e);
      task.dispatch({ type: "set_current_task", payload: await API.getTaskById(task.id) });
    }
  }

  return (
    <div>
      <Formik
        initialValues={{
          data: data.value,
        }}
        validationSchema={KidneyFunctionTestSchema}
        validateOnChange={true}
        onSubmit={async (values) => {
          if (kidneyFunctionTestQmValue && kidneyFunctionTestQmValue.id) {
            await API.deleteQualityMeasurement({ quality_measurement_ids: [kidneyFunctionTestQmValue.id] });
          }
          const request = await handleField({
            id: data.id,
            value: values.data,
            cpr_id: data.cprId,
            quality_measurement_type_id: values.quality_measurement_type_id,
          });
        }}
      >
        {({ values, errors, setFieldValue, initialValues }) => {
          return (
            <Form>
              <label>Kidney Function Test</label>
              <Select
                defaultValue={initialValue}
                placeholder="Select a measurement"
                options={options}
                onChange={(e) => {
                  setFieldValue("quality_measurement_type_id", e.quality_measurement_type_id)
                  handleMeasurement(e);
                }}
              />
              { showTextInput && (<input
                  className="default"
                  placeholder="e.g. 30"
                  value={values.data || initialValue.value }
                  onChange={async (e) => { setFieldValue("data", e.target.value) }}
                />)
              }
              {initialValues.data !== values.data && !errors.data && (
                <div className="check-cancel-buttons flex">
                  <button className="check small" type="submit">
                    <MdCheck className="check-icon" />
                  </button>
                  <button
                    className="cancel small"
                    onClick={async () => {
                      if (kidneyFunctionTestQmValue && kidneyFunctionTestQmValue.id) {
                        await API.deleteQualityMeasurement({ quality_measurement_ids: [kidneyFunctionTestQmValue.id] });
                      }
                      initialValues.data
                        ? setFieldValue("data", initialValues.data)
                        : setFieldValue("data", "");
                    }}
                  >
                    <MdClose className="cancel-icon" />
                  </button>
                </div>
              )}
              {errors.data ? <FieldError error={errors.data} /> : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default KidneyFunctionTest;
